<style lang="less" scoped>
  #mylist {
    flex: 1;
  }
  .mylist-container {
    flex-direction: column;
    height: 100%;
    display: flex;
    position: relative;
    .page-content {
      flex: 1;
    }
  }
  .order-add-btn {
     box-shadow: 0 2px 4px 0 rgba(115, 190, 4, 0.45);
  }
  .order-cover {
    margin-bottom: 24px;
  }
  .mobile-bottom-ui-cover {
    border: none;
    box-shadow: none;
    padding: 0;
    .mobile-order-btn-link {
      margin: auto;
    }
    .mobile-order-btn {
      color: white;
      background: #7ed321;
      align-items: center;
      display: flex;
      align-items: center;
      padding: 10px 18px;
      background-color: #7ed321;
      box-shadow: 0 2px 4px 0 rgba(115, 190, 4, 0.45);
      margin-bottom: 32px;

      .mobile-order-btn-area {
        display: flex;
        align-items: center;
        > img {
          margin-right: 10px;
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .order-list-none {
    position: absolute;
    font-size: 24px;
    color: #463b3b;
    opacity: 0.3;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    top: 0;
    z-index: -1;
  }
  @media screen and (max-width: 560px) {
    .area-container-mobile {
      padding-bottom: 80px;
    }
  }
</style>

<template lang="pug">
  #mylist(v-loading="isLoading")
    .mylist-container.area-container.area-container-mobile
      .page-title-area
        h1 {{title}}
        .nav-area
          router-link(to="/orders")
            el-button.order-add-btn(type="success" round) 새로운 주문
      .page-content
        div.order-list-none(v-if="orders.length <= 0").
          주문 내역이 없습니다.
        router-link(:to="`/mylist/${order._id}`" v-for="order in orders")
          mylist-component(v-bind:order="order")
        .mobile.mobile-bottom-ui-cover
          router-link.mobile-order-btn-link(to="orders")
            el-button.mobile-order-btn(type="success" round)
              span.mobile-order-btn-area
                img(src="@/assets/add-circle-white@2x.png")
                span 새로운 주문
</template>

<script>
import mylistComponent from '@/components/mylist';

export default {
  props: {
    title: {
      type: String,
    },
  },
  watch: {
    title(value) {
      this.$store.commit('setTitle', value);
    },
  },
  async mounted() {
    this.isLoading = true;
    this.$store.commit('setTitle', this.title);
    // 나의 주문내역 불러오기
    const { data } = await this.$http.get('/users/me/orders');
    this.orders = data;
    this.isLoading = false;
  },
  data() {
    return {
      orders: [],
      isLoading: false,
    };
  },
  components: {
    mylistComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/mylist.vue